import { z } from "zod";

import { activityTitleSchema, safeHttpUrlSchema } from "./activity.js";

export const pageLinkImportInputSchema = z
  .object({
    url: safeHttpUrlSchema,
    pageTitle: activityTitleSchema,
    idempotencyKey: z.uuid(),
  })
  .strict();

export type PageLinkImportInput = z.infer<typeof pageLinkImportInputSchema>;
